import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% de desconto a partir de {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Poupe {{percentageAmount}}% em artigos selecionados',
  [OfferKindEnum.AmountOffByProducts]: 'Poupe {{amount}} em artigos selecionados',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Poupe {{amount}} a partir de {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 pelo preço de 1 – Só hoje',
  [OfferKindEnum.BogoHalfPrice]: 'Compra 1 e leva 1 a metade do preço',
  [OfferKindEnum.FreeItemByProducts]: 'Hoje: garanta o seu artigo grátis!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Hoje: garanta o seu artigo grátis com valor de encomenda!',
};

export default OfferLabel;
